import useHandleFingerPay from '@hooks/order/useHandleFingerPay';
import useRegisterFingerPay from '@hooks/order/useRegisterFingerPay';
import useScript from '@hooks/useScript';
import { RootState } from '@store/store';
import { openExternalLink, openInternalLink } from '@utils/nativeUtils';
import { useSelector } from 'react-redux';

export interface FingerPayFormProps {
    orderNo: string;
    mallId: string;
    requestedAt: string;
    hashString: string;
    itemName: string;
    paymentAmount: number;
    returnUri: string;
}

const scriptUrl = import.meta.env.VITE_FINGER_PAY_SCRIPT_URL;

function useFingerPay() {
    const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);
    const { paymentMethod } = useSelector((state: RootState) => state.order);
    const handleFingerPay = useHandleFingerPay();
    useRegisterFingerPay();
    useScript({ src: scriptUrl });

    const toQueryString = (
        obj: object,
    ) => new URLSearchParams(
        Object.entries(obj).map(([k, v]) => [k, String(v)]),
    ).toString();

    return (props: FingerPayFormProps) => {
        const params = { ...props, paymentMethod };
        if (isIos) {
            handleFingerPay(params);
        } else {
            const queryString = toQueryString(params);
            const url = `/orders/finger-pay?${queryString}`;
            openInternalLink(url);
        }
    };
}

export default useFingerPay;
